import { render, staticRenderFns } from "./EmploymentOpportunities.vue?vue&type=template&id=2db72fb1&scoped=true&"
import script from "./EmploymentOpportunities.vue?vue&type=script&lang=ts&"
export * from "./EmploymentOpportunities.vue?vue&type=script&lang=ts&"
import style0 from "./EmploymentOpportunities.vue?vue&type=style&index=0&id=2db72fb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db72fb1",
  null
  
)

export default component.exports